import styled from 'styled-components'

export const ProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 20px;
`

export const StatusText = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin: 20px 0;
  text-align: center;
  color: ${({ theme }) => theme.FontColor};
`

export const WeightDisclaimer = styled.p`
  font-size: 12px;
  line-height: 16px;
  margin: 10px 0 0;
  color: ${({ theme }) => theme.FontColor};
`

export const InfoSection = styled.section`
  margin-top: 20px;
`

export const InfoSectionTitle = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.FontColor};
  margin-bottom: 10px;
`

// Declaration runs: "\n" inside run text = paragraph break
export const RichRunsText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-line;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.FontColor};
`

// Nutrient table: Bezeichnung / Anzahl / Einheit

export const NutrientTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  overflow: hidden;
`

export const NutrientRowContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 70px 70px;
  gap: 10px;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.FontColor};
  &:nth-child(even) {
    background-color: rgba(205, 205, 205, 0.15);
  }
`

export const NutrientLabelCell = styled.span`
  overflow-wrap: break-word;
`

export const NutrientAmountCell = styled.span`
  text-align: right;
  font-weight: 600;
`

export const NutrientUnitCell = styled.span`
  text-align: left;
`
